export const VEHICLE_STATES = [
  "Disponible", "Reservado", "Alquilado", "Mantenimiento", "Fuera de servicio",
];

export const STATUS_BADGE = {
  Disponible: "bg-green-100 text-green-800",
  Reservado: "bg-amber-100 text-amber-800",
  Alquilado: "bg-blue-100 text-blue-800",
  Mantenimiento: "bg-gray-200 text-gray-700",
  "Fuera de servicio": "bg-red-100 text-red-700",
};

export const STATUS_DOT = {
  Disponible: "#22c55e",
  Reservado: "#f59e0b",
  Alquilado: "#3b82f6",
  Mantenimiento: "#9ca3af",
  "Fuera de servicio": "#ef4444",
};

export const MAINTENANCE_TYPES = [
  "Cambio de aceite", "Neumáticos", "Frenos", "Batería",
  "Motor", "Transmisión", "Otros",
];

export const DOCUMENT_CATEGORIES = [
  "Registro", "Seguro", "Inspección", "Fotos", "Otros documentos",
];

export function StatusBadge({ status }) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold ${STATUS_BADGE[status] || "bg-gray-100 text-gray-700"}`}
      data-testid={`status-badge-${status}`}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: STATUS_DOT[status] }} />
      {status}
    </span>
  );
}
